import { render, staticRenderFns } from "./StaticRegisterMultiSelect.vue?vue&type=template&id=72eb975a&"
import script from "./StaticRegisterMultiSelect.vue?vue&type=script&lang=js&"
export * from "./StaticRegisterMultiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports